import { createSelector } from "reselect";

const selectWork = (state) => state.work;

export const selectProjects = createSelector(
  [selectWork],
  (work) => work.projects
);
